.features-type-11--centered {
  text-align: center;
}

.features-type-11__cards--dual {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2xl);

  @include above(960px) {
    flex-direction: row;
  }
}

.me-column--hidden {
  display: none;
}
